<template>
  <div>
    <!-- <b-dialog :mshow="mergeShow" > -->
    <slide from="bottom" :show="mergeShow" height="100%">
    <div class="beast-login-warp merge">
      <div class="merge-main">
        <img  class="close" @click="close" src="./assets/close.png">
        <img  class="rule" @click="rule" src="./assets/merge-rule.png">
        <div class="login-head">
          <img src="./assets/wtf.png"></img>
          <p class="title" >手机验证</p>
          <div class="line"></div>
        </div>

        <div class="login-main">
          <div class="merge-title">
            <p>{{ phone }}已被以下账号作为登录手机号</p>
            <p v-if="mergeData.mergeable" >请确认是否合并账号</p>
          </div>
          <div class="merge-member">
            <div class="header-img">
              <img :src="headImg" alt="">
            </div>
            <div class="member-content">
              <p class="name">{{ member.profile.nickName || phone  }}</p>
              <div class="tags">
                <div class="tag">{{ member.level.name }}</div>
                <div class="tag">积分{{ member.point }}</div>
              </div>
            </div>
          </div>
          <div class="merge-tips" v-if="mergeData.mergeable">
            {{ mergeData.attention }}
          </div>
        </div>

        <div class="merge-btn-list">
          <div @click="close" v-if="!mergeData.mergeable" class="login-btn bottom">
            换个手机号验证
          </div>
          <div @click="merge" v-if="mergeData.mergeable" class="login-btn bottom">
            是我的账号，确认合并
          </div>
          <div @click="close" v-if="mergeData.mergeable" class="merge-not-btn bottom">
            不是我的账号，换个手机号验证
          </div>
        </div>
      </div>

    </div>
  </slide>
  <merge-rule :mergeRuleShow="mergeRuleShow" @cancel="ruleClose"></merge-rule>
</div>
</template>

<script>
import Slide from '@/components/slide'
import BDialog from '@/components/dialog/index.vue'

import api from './api.js'
import MergeRule from './merge-rule.vue'
const path = 'http://img.thebeastshop.com/app/benefit/'
const levelImage = [
  `${path}level-zero.jpg`,
  `${path}level-one.jpg`,
  `${path}level-two.jpg`,
  `${path}level-three.jpg`,
  `${path}level-four.jpg`
]
export default {
  components:{
    Slide,
    MergeRule,
    BDialog
  },
  data (){
    return {
      mergeRuleShow: false
    }
  },
  props: {
    mergeShow: {
      default: true
    },
    mergeData:{
      mergeable: false
    },
    phone: ''
  },
  computed: {
    headImg: function(){
      return this.member.profile.avatarUrl || levelImage[this.member.level.id+1]
    },
    member: function(){
      return this.mergeData.subtle
              ? this.mergeData.subtle.member
              : null
    }
  },
  methods: {
    rule: function (){
      this.mergeRuleShow = true
    },
    ruleClose: function(){
      this.mergeRuleShow = false
    },
    close: function (){
      this.$emit('cancel')
    },
    merge: function(){
      if(this.mergeData.mergeable && this.mergeData.subtle){
        api.merge(this.mergeData.subtle.id)
        .then(() => {
          this.$toast("你的账号已合并")
          .then(() => {
            this.$emit('merge')
          })
        })
        .catch(({code , message}) => {
          this.$toast(message)
        })
      }
    }
  }
}
</script>

<style lang="stylus">
@import './index-old.styl'
  .merge
    width 100%
</style>



// WEBPACK FOOTER //
// merge.vue?7363eef6